import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Property } from 'src/typings';
import { PropertyService } from '../property.service';

@Component({
  selector: 'app-property-multi-selector',
  templateUrl: './multi-selector.component.html',
  styleUrls: ['./multi-selector.component.scss']
})
export class MultiSelectorComponent {
  selectable = true;

  removable = true;

  separatorKeysCodes: number[] = [ENTER, COMMA];

  propertyCtrl = new UntypedFormControl();

  filteredProperties: string[] = [];

  properties: string[] = [];

  allProperties: string[] = [];

  @Input() set clearEvent(clearEvent: EventEmitter<boolean>) {
    clearEvent.subscribe(() => {
      this.properties = [];
    });
  }

  @Output() AddEvent: EventEmitter<{ property_id: number; value: string }> = new EventEmitter();

  @Output() RemoveEvent: EventEmitter<{
    property_id: number;
    value: string;
  }> = new EventEmitter();

  @Input() set propertyData(data: { property: Property; folder_id?: number } | undefined) {
    if (!data) return;
    this.property = data.property;
    this.folder_id = data.folder_id;
    this.updateValues();
  }

  property: Property | undefined;

  folder_id: number | undefined;

  @ViewChild('propertyInput') propertyInput: ElementRef<HTMLInputElement> | undefined;

  constructor(private propertyService: PropertyService) {
    this.propertyCtrl.valueChanges.subscribe((value) => {
      if (!value) {
        this.filteredProperties = this.allProperties;
      } else {
        this.filteredProperties = this.allProperties.filter((prop) => {
          return prop.toUpperCase().includes(value.toUpperCase());
        });
      }
    });
  }

  updateValues() {
    if (!this.property || !this.property.id) return;
    this.propertyService
      .getValuesByPropertyId({
        property_id: this.property.id,
        folder_id: this.folder_id
      })
      .subscribe((values) => {
        this.allProperties = values.map((value) => value.value);
        this.filteredProperties = this.allProperties;
      });
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our property
    if (value && this.property && !this.properties.includes(value)) {
      this.properties.push(value);
      this.AddEvent.emit({ property_id: this.property.id, value });
    }

    // Clear the input value
    event.chipInput!.clear();

    this.propertyCtrl.setValue(null);
  }

  remove(value: string): void {
    const index = this.properties.indexOf(value);

    if (index >= 0 && this.property) {
      this.properties.splice(index, 1);
      this.RemoveEvent.emit({ property_id: this.property.id, value });
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.propertyInput && this.property && !this.properties.includes(event.option.viewValue)) {
      this.properties.push(event.option.viewValue);
      this.propertyInput.nativeElement.value = '';
      this.propertyCtrl.setValue(null);
      this.AddEvent.emit({
        property_id: this.property.id,
        value: event.option.viewValue
      });
    }
  }
}
